import { motion } from "framer-motion";
import { Target, Zap } from "lucide-react";
import SceneShell from "../components/SceneShell";
import CastleGraphic from "../components/CastleGraphic";

/**
 * Scene 51 — Archers & Knights = Social Go + Social Pro.
 * Castle remains; warriors fade in across battlements & gate.
 */

export default function Scene51_TheKnights() {
  return (
    <SceneShell variant="ink" align="center" data-testid="scene-the-knights">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at 50% 50%, rgba(150,193,31,0.10) 0%, transparent 60%)",
            "radial-gradient(ellipse at 50% 50%, rgba(150,193,31,0.18) 0%, transparent 60%)",
            "radial-gradient(ellipse at 50% 50%, rgba(150,193,31,0.10) 0%, transparent 60%)",
          ],
        }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative w-full h-full flex flex-col">
        <div className="flex-1 mt-2 mx-auto w-full max-w-[1400px] relative">
          <CastleGraphic layer={2} />

          {/* Two callouts — Social Go (lime) on the left, Social Pro (gold) on the right */}
          <motion.div
            initial={{ opacity: 0, x: -16 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 1.5, ease: [0.16, 1, 0.3, 1] }}
            className="absolute top-[18%] left-[6%] z-10"
            data-testid="knights-callout-go"
          >
            <div
              className="rounded-2xl px-5 py-3"
              style={{
                background: "rgba(150,193,31,0.10)",
                border: "1px solid rgba(150,193,31,0.50)",
                boxShadow: "0 0 50px rgba(150,193,31,0.22)",
              }}
            >
              <div
                className="text-[10px] tracking-[0.32em] uppercase mb-1 flex items-center gap-1.5"
                style={{ color: "#96C11F" }}
              >
                <Zap className="w-3 h-3" />
                Archers
              </div>
              <div
                className="kn-display text-lg sm:text-xl"
                style={{ color: "#e2e8f0", fontWeight: 700 }}
              >
                Social <span style={{ color: "#96C11F" }}>Go</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 16 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 1.8, ease: [0.16, 1, 0.3, 1] }}
            className="absolute top-[18%] right-[6%] z-10"
            data-testid="knights-callout-pro"
          >
            <div
              className="rounded-2xl px-5 py-3"
              style={{
                background: "rgba(229,0,100,0.10)",
                border: "1px solid rgba(229,0,100,0.55)",
                boxShadow: "0 0 50px rgba(229,0,100,0.30)",
              }}
            >
              <div
                className="text-[10px] tracking-[0.32em] uppercase mb-1 flex items-center gap-1.5"
                style={{ color: "#e50064" }}
              >
                <Target className="w-3 h-3" />
                Knights
              </div>
              <div
                className="kn-display text-lg sm:text-xl"
                style={{ color: "#e2e8f0", fontWeight: 700 }}
              >
                Social <span style={{ color: "#e50064" }}>Pro</span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom tagline */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 2.4 }}
          className="text-center text-base sm:text-xl mb-2"
          style={{ color: "rgba(255,255,255,0.75)" }}
        >
          They <span style={{ color: "#96C11F", fontWeight: 700 }}>attack</span> outwards ·
          they <span style={{ color: "#e50064", fontWeight: 700 }}>expand</span> our reach.
        </motion.div>
      </div>
    </SceneShell>
  );
}
